import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {typePrefix} from './action'
import mapRequest from '@apis/map'

const initialState = {
  isShowSavePhraseForm: false,
  phraseToSave: null,
  currentTopic: null,
  isShowReportErrorForm: false,
  isShowModalPromoterScore: false,
  isShowModalFeedbackRealTime: false,
  isShowModalExitFlow: false,
  dataFeedbackOverview: null,
  currentCourseId: null,
  isShowInAppBrowser: false
}

export const sharedSlice = createSlice({
  name: 'shared',
  initialState,
  reducers: {
    updateIsShowSavePhraseForm: (state, action) => {
      state.isShowSavePhraseForm = action.payload
    },
    updatePhraseToSave: (state, action) => {
      state.phraseToSave = action.payload
    },
    updateCurrentTopic: (state, action) => {
      state.currentTopic = action.payload
    },
    updateIsShowReportErrorForm: (state, action) => {
      state.isShowReportErrorForm = action.payload
    },
    updateIsShowModalPromoterScore: (state, action) => {
      state.isShowModalPromoterScore = action.payload
    },
    updateIsShowModalFeedbackRealTime: (state, action) => {
      state.isShowModalFeedbackRealTime = action.payload
    },
    updateIsShowModalExitFlow: (state, action) => {
      state.isShowModalExitFlow = action.payload
    },
    updateDataFeedbackOverview: (state, action) => {
      state.dataFeedbackOverview = action.payload
    },
    updateCurrentCourseId: (state, action) => {
      state.currentCourseId = action.payload
    },
    updateIsShowInAppBrowser: (state, action) => {
      state.isShowInAppBrowser = action.payload
    },
    reset: () => {
      return initialState
    },
  },
  extraReducers: builder => {
    builder.addCase(
      getFeedbackOverview.pending,
      (state: any, action: any) => {},
    )
    builder.addCase(
      getFeedbackOverview.fulfilled,
      (state: any, action: any) => {
        state.dataFeedbackOverview = action.payload?.data
      },
    )
    builder.addCase(
      getFeedbackOverview.rejected,
      (state: any, action: any) => {},
    )
  },
})

export const {
  updateIsShowSavePhraseForm,
  updatePhraseToSave,
  updateCurrentTopic,
  updateIsShowReportErrorForm,
  updateIsShowModalPromoterScore,
  updateIsShowModalFeedbackRealTime,
  updateIsShowModalExitFlow,
  updateDataFeedbackOverview,
  updateCurrentCourseId,
  updateIsShowInAppBrowser,
  reset,
} = sharedSlice.actions

export const getFeedbackOverview = createAsyncThunk(
  typePrefix.GET_FEEDBACK_OVERVIEW,
  async () => {
    const response = await mapRequest.getFeedbackOverview()
    return response.data
  },
)

export default sharedSlice.reducer
